<template>
  <div class="register-page">
    <div class="form-card" v-show="!registerFlag">
        <header class="form-head">
          <div class="welcome">创建账号</div>
          <div class="welcome-sub">完善以下信息完成注册</div>
        </header>

        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="register-form"
        >
          <el-form-item prop="hospitalName">
            <label class="field-label">所属机构</label>
            <el-input v-model="ruleForm.hospitalName" placeholder="医疗机构全称" size="large" />
          </el-form-item>

          <el-form-item prop="departmentName">
            <label class="field-label">所属科室</label>
            <el-input v-model="ruleForm.departmentName" placeholder="科室名称" size="large" />
          </el-form-item>

          <div class="row-2">
            <el-form-item prop="name">
              <label class="field-label">真实姓名</label>
              <el-input v-model="ruleForm.name" placeholder="请输入姓名" size="large" />
            </el-form-item>

            <el-form-item prop="sex" class="sex-item">
              <label class="field-label">性别</label>
              <el-radio-group v-model="ruleForm.sex" class="sex-group" size="large">
                <el-radio-button :label="0">男</el-radio-button>
                <el-radio-button :label="1">女</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </div>

          <el-form-item prop="phone">
            <label class="field-label">手机号</label>
            <div class="phone-row">
              <el-input v-model="ruleForm.phone" placeholder="请输入手机号" size="large" />
              <el-button
                class="code-btn"
                :disabled="loginCodeInfo.getCodeisWaiting"
                @click="getLoginCode"
              >{{ loginCodeInfo.getCodeText }}</el-button>
            </div>
          </el-form-item>

          <el-form-item prop="code">
            <label class="field-label">验证码</label>
            <el-input v-model="ruleForm.code" placeholder="请输入验证码" size="large" />
          </el-form-item>

          <el-form-item prop="userName">
            <label class="field-label">用户名</label>
            <el-input v-model="ruleForm.userName" placeholder="2-20 位字符" size="large" />
          </el-form-item>

          <div class="row-2">
            <el-form-item prop="loginPassword">
              <label class="field-label">登录密码</label>
              <el-input
                v-model="ruleForm.loginPassword"
                type="password"
                placeholder="6-20 位"
                size="large"
                show-password
              />
            </el-form-item>

            <el-form-item prop="confirmPassword">
              <label class="field-label">确认密码</label>
              <el-input
                v-model="ruleForm.confirmPassword"
                type="password"
                placeholder="再次输入"
                size="large"
                show-password
              />
            </el-form-item>
          </div>

          <div class="agree-row">
            <el-checkbox v-model="ruleForm.userAgreement">已阅读并同意</el-checkbox>
            <span class="link" @click="userService">《用户服务协议》</span>
          </div>

          <el-button
            class="submit-btn"
            type="primary"
            size="large"
            @click="submitForm('ruleForm')"
          >注 册</el-button>

          <div class="form-bottom">
            已有账号？<span class="link strong" @click="login">立即登录</span>
          </div>
        </el-form>
      </div>

    <!-- 注册成功 -->
    <div class="form-card success-card" v-show="registerFlag">
      <div class="success-icon">
        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="32" cy="32" r="30" fill="#E6F7F5" stroke="#2EAD9E" stroke-width="1.5"/>
          <path d="M20 33l8 8 16-18" stroke="#2EAD9E" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
        </svg>
      </div>
      <div class="success-title">注册成功</div>
      <div class="success-sub">您的账号已提交，请等待管理员审核激活后方可登录</div>
      <el-button class="submit-btn" type="primary" size="large" @click="login">前 往 登 录</el-button>
    </div>

    <el-dialog v-model="userServiceFlag" title="用户服务协议" width="700" center>
      <div class="dialog-con">
        <div class="date">
          <p>生效日期：2023年10月15日</p>
          <p>更新日期：2023年10月15日</p>
        </div>
        <div class="d-title">
          欢迎使用极医堂智能舌面分析系统（以下简称"舌面仪"或"本产品"），
          本产品由南京极医堂药信息技术有限公司提供支持。在使用本产品之前，
          请您仔细阅读本协议（以下简称"协议"）。若您使用本产品，即表示您同意遵守本协议的所有条款和条件。
        </div>
        <div class="item">
          <div class="item-title">一、服务内容</div>
          <div class="item-line">
            <p>1. 舌面仪是一种基于人工智能技术的舌诊系统，旨在通过分析舌面图像来提供舌诊结果。本产品将通过图像识别技术分析用户提供的舌面图像，并根据分析结果提供相应的舌诊建议。</p>
            <p>2. 本产品仅供参考，不作为医疗诊断的依据。用户在接受舌诊结果和建议时，应自行判断并谨慎决策。如需获得准确的医疗诊断和治疗，请咨询专业医生。</p>
            <p>3. 用户可以通过上传舌面图像的方式使用本产品。用户应确保所上传的舌面图像真实、准确、合法，不侵犯他人的合法权益。用户上传的舌面图像将仅用于舌诊分析，不会被用于其他目的。</p>
          </div>
        </div>
        <div class="item">
          <div class="item-title">二、用户权利和义务</div>
          <div class="item-line">
            <p>1. 用户有权自主选择是否使用本产品，并自行承担使用本产品的风险。</p>
            <p>2. 用户应保证所提供的个人信息真实、准确、完整，并及时更新。</p>
            <p>3. 用户应妥善保管自己的账号和密码，不得将其提供给他人使用。用户应对通过其账号和密码进行的所有活动负责。</p>
            <p>4. 用户不得利用本产品从事违法、违规、侵权或其他损害他人合法权益的活动。</p>
            <p>5. 用户应尊重本产品的知识产权和其他合法权益，不得以任何方式侵犯本产品的权益。</p>
          </div>
        </div>
        <div class="item">
          <div class="item-title">三、知识产权保护</div>
          <div class="item-line">
            <p>1. 本产品所包含的软件、技术、图像、文字、标识等知识产权归南京极医堂药信息技术有限公司所有，受法律保护。</p>
            <p>2. 未经南京极医堂药信息技术有限公司的明确授权，用户不得以任何形式复制、修改、传播、展示、演示、发行或使用本产品的内容。</p>
          </div>
        </div>
        <div class="item">
          <div class="item-title">四、免责声明</div>
          <div class="item-line">
            <p>1. 用户理解并同意，本产品仅提供舌诊结果和建议，不对结果的准确性、可靠性、完整性做出任何保证。</p>
            <p>2. 用户理解并同意，本产品无法替代医生的诊断和治疗，用户在接受舌诊结果和建议时，应自行判断并谨慎决策。</p>
            <p>3. 用户理解并同意，使用本产品所产生的一切风险由用户自行承担，本产品及南京极医堂药信息技术有限公司不承担任何责任。</p>
          </div>
        </div>
        <div class="item">
          <div class="item-title">五、协议的修改和终止</div>
          <div class="item-line">
            <p>1. 南京极医堂药信息技术有限公司有权随时修改本协议的内容，并通过适当方式向用户公布。用户继续使用本产品即视为接受修改后的协议。</p>
            <p>2. 用户可以随时终止使用本产品，或者与南京极医堂药信息技术有限公司协商解除协议。</p>
            <p>3. 南京极医堂药信息技术有限公司有权随时终止向用户提供本服务，并有权删除用户的账号和相关信息。</p>
          </div>
        </div>
        <div class="item">
          <div class="item-title">六、其他条款</div>
          <div class="item-line">
            <p>1. 本协议适用中华人民共和国的法律。</p>
            <p>2. 若本协议中的任何条款被认定为无效或不可执行，不影响其他条款的效力。</p>
            <p>3. 本协议的解释权归南京极医堂药信息技术有限公司所有。</p>
          </div>
        </div>
        <div class="d-footer">
          请您在使用本产品之前，仔细阅读并理解本协议的全部内容。如您对本协议有任何疑问，请及时联系南京极医堂药信息技术有限公司人工客服（025-58285029）。您使用本产品即表示您已阅读、理解并同意接受本协议的全部内容。
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  // 手机号验证规则
  const validatePhon = (rule, value, callback) => {
    if (value === '') {
      callback(new Error('请输入手机号码'))
    } else if (!/^1[3|4|5|7|8|9][0-9]{9}$/.test(value)) {
      callback(new Error('请输入正确的手机号码'))
    } else {
      callback()
    }
  }

  export default {
    data() {
      const validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'))
        } else if (value !== this.ruleForm.loginPassword) {
          callback(new Error('两次输入密码不一致'))
        } else {
          callback()
        }
      }

      return {
        registerFlag: false,
        ruleForm: {
          hospitalName: '',
          departmentName: '',
          name: '',
          sex: 0,
          userName: '',
          phone: '',
          code: '',
          loginPassword: '',
          confirmPassword: '',
          userAgreement: true,
        },
        rules: {
          hospitalName: [{ required: true, message: '请输入医疗机构全称', trigger: 'blur' }],
          phone: [
            { required: true, validator: validatePhon, trigger: 'blur' },
          ],
          code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
          name: [{ required: true, message: '请输入真实姓名', trigger: 'blur' }],
          userName: [
            { required: true, message: '请输入用户名', trigger: 'blur' },
            { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'change' },
          ],
          sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
          loginPassword: [
            { required: true, message: '请输入登录密码', trigger: 'blur' },
            { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'change' },
          ],
          confirmPassword: [
            { required: true, message: '请输入确认密码', trigger: 'blur' },
            { validator: validatePass, trigger: 'change' },
          ],
        },
        propertiesData: {},
        sn: '',
        loginCodeInfo: {
          holdTime: 60,
          getCodeText: '获取验证码',
          getCodeisWaiting: false,
          codeTimer: null,
        },
        userServiceFlag: false,
      }
    },

    methods: {
      submitForm(formName) {
        if (!this.ruleForm.userAgreement) {
          this.$message.warning('请先阅读并同意《用户服务协议》')
          return
        }
        this.$refs[formName].validate(valid => {
          if (valid) this.register()
        })
      },

      login() {
        this.$router.push('/login/login')
      },

      getLoginCode() {
        if (this.loginCodeInfo.getCodeisWaiting) return
        if (!/^1[3|4|5|7|8|9][0-9]{9}$/.test(this.ruleForm.phone)) {
          this.$message.warning('请输入正确的手机号码')
          return
        }
        this.getDoctorSms(this.ruleForm.phone, 1)
      },

      getDoctorSms(phone, type) {
        this.loginCodeInfo.getCodeisWaiting = true
        this.$applicationJson('business/user/sms', { phone, type }).then(res => {
          const code = Number(res.data.code)
          if (code === 200) {
            this.$message.success('验证码已发送')
            this.setTimer(this.loginCodeInfo)
          } else {
            this.loginCodeInfo.getCodeisWaiting = false
            this.$message.error(res.data.msg || '验证码发送失败')
          }
        }).catch(() => {
          this.loginCodeInfo.getCodeisWaiting = false
          this.$message.error('网络异常')
        })
      },

      setTimer(info) {
        info.holdTime = 60
        info.getCodeText = '重新获取(60)'
        info.getCodeisWaiting = true
        info.codeTimer = setInterval(() => {
          if (info.holdTime <= 0) {
            info.getCodeisWaiting = false
            info.getCodeText = '获取验证码'
            clearInterval(info.codeTimer)
            return
          }
          info.getCodeText = '重新获取(' + info.holdTime + ')'
          info.holdTime--
        }, 1000)
      },

      register() {
        this.$applicationJson('/business/user/register', {
          hospitalName: this.ruleForm.hospitalName,
          departmentName: this.ruleForm.departmentName,
          name: this.ruleForm.name,
          gender: this.ruleForm.sex,
          username: this.ruleForm.userName,
          password: this.ruleForm.loginPassword,
          sn: this.sn,
          phone: this.ruleForm.phone,
          captcha: this.ruleForm.code,
        }).then(res => {
          if (res.data.code == 0) {
            this.registerFlag = true
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(() => {
          this.$message.error('网络异常')
        })
      },

      userService() {
        this.userServiceFlag = true
      },
    },

    created() {
      this.$nextTick(() => {
        if (typeof window.parseProps === 'function') {
          this.propertiesData = window.parseProps() || {}
          if (this.propertiesData.sn) this.sn = this.propertiesData.sn
        }
      })
    },
  }
</script>

<style lang="less" scoped="scoped">
  // ── Design Tokens（与 login 页一致，本页内联） ──
  @primary-50:  #E6F7F5;
  @primary-100: #C2EDE7;
  @primary-300: #5CCABD;
  @primary-500: #2EAD9E;
  @primary-600: #258F83;
  @primary-700: #1D7268;
  @primary-800: #15544D;

  @gray-0:   #FFFFFF;
  @gray-50:  #FAFAF8;
  @gray-100: #F4F3F0;
  @gray-200: #E8E6E1;
  @gray-300: #DAD7D0;
  @gray-400: #B0ADA6;
  @gray-500: #8A8780;
  @gray-700: #4D4A43;
  @gray-800: #33312B;

  @danger-500: #D14B3F;

  @font-display: 'Noto Serif SC', 'SimSun', serif;
  @font-body:    'Noto Sans SC', 'Microsoft YaHei', sans-serif;

  .register-page {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    background: @gray-50;
    font-family: @font-body;
    color: @gray-800;
    overflow-y: auto;
    padding: 48px 24px;
  }

  .form-card {
    width: 100%;
    max-width: 640px;
    margin: auto 0;
    background: @gray-0;
    border: 1px solid @gray-200;
    border-radius: 16px;
    box-shadow:
      0 1px 2px rgba(53, 51, 45, 0.04),
      0 12px 32px rgba(46, 173, 158, 0.06);
    padding: 48px 56px;
    box-sizing: border-box;
  }

  .form-head {
    margin-bottom: 28px;
    .welcome {
      font-family: @font-display;
      font-size: 30px;
      font-weight: 600;
      color: @gray-800;
      letter-spacing: 2px;
    }
    .welcome-sub {
      margin-top: 6px;
      font-size: 13px;
      color: @gray-500;
      letter-spacing: 0.5px;
    }
  }

  .register-form {
    .field-label {
      display: block;
      font-size: 12px;
      color: @gray-500;
      margin-bottom: 6px;
      letter-spacing: 1px;
      font-weight: 500;
    }

    :deep(.el-form-item) {
      margin-bottom: 18px;
    }
    :deep(.el-form-item__content) {
      line-height: 1.4;
      flex-direction: column;
      align-items: stretch;
    }
    :deep(.el-form-item__error) {
      padding-top: 4px;
    }

    :deep(.el-input__wrapper) {
      background: @gray-0;
      border-radius: 10px;
      box-shadow: 0 0 0 1px @gray-200 inset;
      transition: box-shadow 200ms ease;
      padding: 4px 14px;
      &:hover {
        box-shadow: 0 0 0 1px @primary-300 inset;
      }
      &.is-focus {
        box-shadow: 0 0 0 1.5px @primary-500 inset, 0 0 0 4px @primary-50;
      }
    }
    :deep(.el-input__inner) {
      height: 42px;
      font-size: 14px;
      color: @gray-800;
      &::placeholder { color: @gray-400; }
    }

    .row-2 {
      display: flex;
      gap: 14px;
      :deep(.el-form-item) {
        flex: 1;
        min-width: 0;
      }
      .sex-item { flex: 0 0 168px; }
    }

    .sex-group {
      width: 100%;
      :deep(.el-radio-button) {
        flex: 1;
        .el-radio-button__inner {
          width: 100%;
          height: 42px;
          line-height: 1;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: @gray-0;
          border-color: @gray-200;
          color: @gray-700;
          font-size: 14px;
          letter-spacing: 4px;
          transition: all 200ms ease;
          box-shadow: none;
          &:hover { color: @primary-600; }
        }
        &:first-child .el-radio-button__inner {
          border-radius: 10px 0 0 10px;
        }
        &:last-child .el-radio-button__inner {
          border-radius: 0 10px 10px 0;
        }
      }
      :deep(.el-radio-button__original-radio:checked + .el-radio-button__inner) {
        background: @primary-500;
        border-color: @primary-500;
        color: #fff;
        box-shadow: -1px 0 0 0 @primary-500;
      }
    }

    .phone-row {
      display: flex;
      gap: 10px;
      :deep(.el-input) { flex: 1; }
      .code-btn {
        flex: 0 0 116px;
        height: 42px;
        padding: 0 12px;
        font-size: 13px;
        background: @primary-50;
        color: @primary-600;
        border: 1px solid @primary-100;
        border-radius: 10px;
        letter-spacing: 1px;
        transition: all 200ms ease;
        &:hover:not(:disabled) {
          background: @primary-100;
          color: @primary-700;
          border-color: @primary-300;
        }
        &:disabled {
          color: @gray-400;
          background: @gray-100;
          border-color: @gray-200;
          cursor: not-allowed;
        }
      }
    }

    .agree-row {
      display: flex;
      align-items: center;
      gap: 4px;
      margin: 4px 0 22px;
      :deep(.el-checkbox__label) {
        font-size: 13px;
        color: @gray-700;
        padding-left: 8px;
      }
      :deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
        background: @primary-500;
        border-color: @primary-500;
      }
      :deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
        color: @gray-700;
      }
    }

    .submit-btn {
      width: 100%;
      height: 48px;
      border-radius: 10px;
      font-size: 15px;
      letter-spacing: 8px;
      font-weight: 500;
      background: linear-gradient(135deg, @primary-500, @primary-600);
      border: none;
      box-shadow: 0 6px 20px rgba(46, 173, 158, 0.32);
      transition: transform 200ms ease, box-shadow 200ms ease;
      &:hover {
        background: linear-gradient(135deg, @primary-500, @primary-700);
        box-shadow: 0 10px 28px rgba(46, 173, 158, 0.38);
        transform: translateY(-1px);
      }
      &:active {
        transform: translateY(0);
      }
    }

    .form-bottom {
      margin-top: 18px;
      text-align: center;
      font-size: 13px;
      color: @gray-500;
    }

    .link {
      cursor: pointer;
      color: @primary-600;
      font-size: 13px;
      transition: color 150ms ease;
      &:hover { color: @primary-700; }
      &.strong { font-weight: 600; }
    }
  }

  /* ─────── 注册成功 ─────── */
  .success-card {
    text-align: center;
    padding: 40px 0;
    .success-icon {
      width: 80px;
      height: 80px;
      margin: 0 auto 24px;
      svg { width: 100%; height: 100%; }
    }
    .success-title {
      font-family: @font-display;
      font-size: 28px;
      font-weight: 600;
      color: @gray-800;
      letter-spacing: 4px;
      margin-bottom: 8px;
    }
    .success-sub {
      font-size: 13px;
      color: @gray-500;
      letter-spacing: 0.5px;
      margin-bottom: 32px;
    }
    .submit-btn {
      width: 100%;
      max-width: 280px;
      height: 48px;
      border-radius: 10px;
      font-size: 15px;
      letter-spacing: 6px;
      font-weight: 500;
      background: linear-gradient(135deg, @primary-500, @primary-600);
      border: none;
      box-shadow: 0 6px 20px rgba(46, 173, 158, 0.32);
      &:hover {
        background: linear-gradient(135deg, @primary-500, @primary-700);
      }
    }
  }

  /* ─────── 协议弹窗 ─────── */
  :deep(.el-dialog__header) { font-weight: bold; }
  :deep(.el-dialog__body) { padding: 0; }
  .dialog-con {
    font-size: 14px;
    height: 600px;
    overflow-y: auto;
    padding: 25px calc(var(--el-dialog-padding-primary) + 5px) 30px;
    color: @gray-700;
    .date {
      width: 100%;
      text-align: right;
      color: @gray-500;
      p { line-height: 24px; }
    }
    .d-title {
      margin-top: 20px;
      line-height: 1.8;
    }
    .item {
      margin-top: 20px;
      .item-title {
        font-weight: 600;
        font-size: 15px;
        line-height: 30px;
        color: @gray-800;
      }
      .item-line p {
        margin-bottom: 5px;
        line-height: 1.8;
      }
    }
    .d-footer {
      margin-top: 20px;
      line-height: 1.8;
    }
  }

  /* ─────── 响应式 ─────── */
  @media (max-width: 720px) {
    .register-page {
      padding: 24px 16px;
    }
    .form-card {
      padding: 32px 24px;
      border-radius: 12px;
    }
    .register-form .row-2 {
      flex-direction: column;
      gap: 0;
      .sex-item { flex: 1; }
    }
  }
</style>
